import { FEEDBACK_FORM_TYPE } from 'constants/ProjectConstants';
import {
  getDateFromEpoch,
  getFeedbackFormRoute,
  getFeedDetailRoute,
  getOneOnOneInstancePageRoute,
  getPulseSurveyRoute,
  getReviewFormRoute,
} from 'constants/helper';

import Source from './source';

const REVIEW_SUB_EVENT_TYPES_ARRAY = [
  'PEER_NOMINATION_ACCEPT',
  'PEER_NOMINATION_DECLINE',
  'SELF_REVIEW_REQUEST',
  'MANAGER_REVIEW_REQUEST',
  'UPWARD_REVIEW_REQUEST',
  'FEEDBACK_REQUEST',
  'PEER_REMINDER',
  'MANAGER_REMINDER',
  'UPWARD_REMINDER',
];

const NOTIFICATION_TYPES = {
  POST: 'POST',
  COMMENT: 'COMMENT',
  REVIEW: 'REVIEW',
  ONE_ON_ONE: 'ONE_ON_ONE',
  FEEDBACK: 'FEEDBACK',
  ENGAGEMENT: 'ENGAGEMENT',
};

const REVIEW_NOTIFICATION_SUB_EVENTS = {
  PEER_NOMINATION_REQUEST: 'PEER_NOMINATION_REQUEST',
  FEEDBACK_SHARED: 'FEEDBACK_SHARED',
  SELF_REMINDER: 'SELF_REMINDER',
  SELF_MANAGER_SUMMARY: 'SELF_MANAGER_SUMMARY',
  PEER_REMINDER: 'PEER_REMINDER',
  PEER_MANAGER_SUMMARY: 'PEER_MANAGER_SUMMARY',
  MANAGER_REMINDER: 'MANAGER_REMINDER',
  MANAGER_MANAGER_SUMMARY: 'MANAGER_MANAGER_SUMMARY',
  UPWARD_REMINDER: 'UPWARD_REMINDER',
  UPWARD_MANAGER_SUMMARY: 'UPWARD_MANAGER_SUMMARY',
};

const REVIEW_MANAGER_SUMMARY_SUB_EVENTS = [
  REVIEW_NOTIFICATION_SUB_EVENTS.UPWARD_MANAGER_SUMMARY,
  REVIEW_NOTIFICATION_SUB_EVENTS.MANAGER_MANAGER_SUMMARY,
  REVIEW_NOTIFICATION_SUB_EVENTS.PEER_MANAGER_SUMMARY,
  REVIEW_NOTIFICATION_SUB_EVENTS.SELF_MANAGER_SUMMARY,
];

const ENGAGEMENT_NOTIFICATION_SUB_EVENTS = {
  ENGAGEMENT_REMINDER: 'ENGAGEMENT_REMINDER',
  ENGAGEMENT_MANAGER_SUMMARY: 'ENGAGEMENT_MANAGER_SUMMARY',
};

const ONE_ON_ONE_NOTIFICATION_SUB_EVENTS = {
  ONE_ON_ONE_REMINDER: 'ONE_ON_ONE_REMINDER',
};

const NOTIFICATION_SUB_EVENT_TYPES = {
  REVIEW: REVIEW_NOTIFICATION_SUB_EVENTS,
  ENGAGEMENT: ENGAGEMENT_NOTIFICATION_SUB_EVENTS,
  ONE_ON_ONE: ONE_ON_ONE_NOTIFICATION_SUB_EVENTS,
};

export default class NotificationModel {
  constructor() {
    this.isClicked = false;
    this.createdDate = null;
    this.id = null;
    this.source = null;
    this.text = '';
  }

  isEmployeeType() {
    return this.source && this.source.type && this.source.type === 'EMPLOYEE';
  }

  // source is an object of Source model
  fromProps({
    id,
    isClicked,
    createdDate,
    source,
    type,
    text,
    macros,
    landingPageId,
    parent,
    landingPageIds,
    url,
    getUrl,
  }) {
    this.id = id;
    this.createdDate = createdDate;
    this.isClicked = isClicked;
    this.source = source;
    this.type = type;
    this.text = text;
    this.macros = macros;
    this.landingPageId = landingPageId;
    this.landingPageIds = landingPageIds;
    this.parent = parent;
    this.url = url;
    this.getUrl = getUrl;
  }

  fromJSON(json) {
    const isClicked = json.clicked;
    const { text } = json;
    const { macros } = json;
    const { type } = json;
    const id = json.uuid;
    const createdDate = json.createdTS && getDateFromEpoch(json.createdTS);
    const { landingPageId } = json;
    const { landingPageIds } = json;
    const { url } = json;
    let source;
    if (json.source) {
      source = new Source();
      source.fromJSON(json.source);
    }
    let parent;
    if (json.parent) {
      parent = json.parent;
    }
    this.fromProps({
      isClicked,
      text,
      id,
      createdDate,
      type,
      source,
      macros,
      landingPageId,
      parent,
      landingPageIds,
      url,
      getUrl: this.getUrl,
    });
  }

  getUrl() {
    if (this.url) {
      const url = new URL(this.url);
      return url.pathname + url.search + url.hash;
    }
    // read feeddetailroute from landingPageIds for post as well.
    if (this.type === NOTIFICATION_TYPES.POST || this.type === NOTIFICATION_TYPES.COMMENT) {
      // return getFeedDetailRoute(this.landingPageId);
      // } else if () {
      // if (this.parent) {
      //   return getFeedDetailRoute(this.parent.uuid);
      // } else return getFeedDetailRoute(this.landingPageId);
      if (this.landingPageIds && Array.isArray(this.landingPageIds) && this.landingPageIds.length) {
        return getFeedDetailRoute(this.landingPageIds[0]);
      }
    } else if (this.type === NOTIFICATION_TYPES.REVIEW) {
      if (this?.macros?.SubEventType) {
        // do navigation based on SubEventType
        if (this.landingPageIds && Array.isArray(this.landingPageIds) && this.landingPageIds.length) {
          return getFeedDetailRoute(this.landingPageIds[0]);
        }
      } else if (this.type === NOTIFICATION_TYPES.REVIEW) {
        if (this?.macros?.SubEventType) {
          // do navigation based on SubEventType
          if (this.macros.SubEventType === NOTIFICATION_SUB_EVENT_TYPES.REVIEW.PEER_NOMINATION_REQUEST) {
            const { LandingPageId, ActorId } = this.macros ?? {};
            return getReviewFormRoute(LandingPageId, ActorId);
          }

          if (REVIEW_SUB_EVENT_TYPES_ARRAY.includes(this.macros.SubEventType)) {
            return '/review';
          }
          if (REVIEW_MANAGER_SUMMARY_SUB_EVENTS.includes(this.macros.SubEventType)) {
            return '/review#teamStatus';
          }

          if (this.macros.SubEventType === NOTIFICATION_SUB_EVENT_TYPES.REVIEW.SELF_REMINDER) {
            const { LandingPageId, ActorId } = this.macros ?? {};
            return getReviewFormRoute(LandingPageId, ActorId);
          }
        } else {
          return '/';
        }
      } else if (this.type === NOTIFICATION_TYPES.ONE_ON_ONE) {
        if (this.landingPageIds && Array.isArray(this.landingPageIds) && this.landingPageIds.length) {
          return `${getOneOnOneInstancePageRoute(this.landingPageIds[0])}?ref=OneOnOne`;
        }
        if (this.macros.SubEventType === NOTIFICATION_SUB_EVENT_TYPES.ONE_ON_ONE.ONE_ON_ONE_REMINDER) {
          if (this.landingPageIds && Array.isArray(this.landingPageIds) && this.landingPageIds.length) {
            return `${getOneOnOneInstancePageRoute(this.landingPageIds[0])}?ref=OneOnOne`;
          }
        }
        return '/oneOnOne?ref=OneOnOne';
      } else if (this.type === NOTIFICATION_TYPES.FEEDBACK) {
        if (this.macros.SubEventType === 'FEEDBACK_SHARED') {
          if (this.landingPageIds && Array.isArray(this.landingPageIds) && this.landingPageIds.length) {
            return getFeedbackFormRoute({
              formType: FEEDBACK_FORM_TYPE.PROVIDED,
              show: true,
              feedbackId: this.landingPageIds[0],
            });
          }
        }
      } else if (this.type === NOTIFICATION_TYPES.ENGAGEMENT) {
        if (this.macros.SubEventType === NOTIFICATION_SUB_EVENT_TYPES.ENGAGEMENT.ENGAGEMENT_REMINDER) {
          const { LandingPageId } = this.macros ?? {};
          return getPulseSurveyRoute(LandingPageId);
        }

        if (this.macros.SubEventType === NOTIFICATION_SUB_EVENT_TYPES.ENGAGEMENT.ENGAGEMENT_MANAGER_SUMMARY) {
          return '/';
        }
      } else {
        // const feeds = ['1466344', '1466340', '1466336', '1466308'];
        // const randomInt = getRandomInt;
        // const index = getRandomInt(4);
        // return getFeedDetailRoute(feeds[index]);
        return '/';
      }
    }
  }
}
